<template>
    <svg :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
        <path d="M29.4,42.9h-11.5c-.3,0-.5-.2-.5-.5v-15.5c0-.3.2-.5.5-.5h11.5c4.5,0,8.1,3.7,8.1,8.2s-3.6,8.1-8.1,8.2ZM26.6,7.1c4,0,7.2,3.3,7.2,7.3s-3.2,7.2-7.2,7.3h-8.8c-.3,0-.5-.2-.5-.5V7.6c0-.3.2-.5.5-.5h8.8ZM35.1,23c3.5-3.5,4.5-8.6,2.7-13.2-1.8-4.5-6.2-7.5-11.1-7.6H10.1c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4h2c.3,0,.5.2.5.5v34.9c0,.3-.2.5-.5.5h-2c-1.3,0-2.4,1.1-2.4,2.4s1.1,2.4,2.4,2.4h19.3c6,0,11.3-4.2,12.6-10.1,1.4-5.9-1.5-11.9-6.9-14.6h0Z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>